import { jsx as _jsx } from "react/jsx-runtime";
import { GyroAssistantCore } from './GyroAssistant.js';
import { FULL_PARTS } from './fullParts.js';
/**
 * <GyroAssistant>, the whole widget (`@exante/gyro-react`): the floating panel on a web page, the Office pane (layout="pane",
 * clientTools, clientActions) and the desktop app (appKey "desktop"). Files made from an answer (on the desktop and in the
 * pane) load their writers on demand, the first time a person makes one. A web page that needs none of that can import
 * `@exante/gyro-react/web` instead: the same props, look and keys, without the desktop, Office-pane and document parts.
 */
export function GyroAssistant(props) {
    return _jsx(GyroAssistantCore, { ...props, parts: FULL_PARTS });
}
//# sourceMappingURL=GyroAssistantFull.js.map